import React, { useState } from 'react';
import { withRouter } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import 'bootstrap-daterangepicker/daterangepicker.css';
import { humanize } from "../../helper/utils";
import moment from 'moment'
import { useEffect } from 'react';
import { getPaginatedList } from "../../services/baseServices";
import {toast} from 'react-toastify'
import ExportCSV from '../common/ExportCSV';

const headers = [
  { label: "Order", key: "order_id" },
  { label: "Order Date", key: "order_at" },
  { label: "Delivery Date", key: "delivery_date" },
  { label: "Type", key: "order_type" },
  { label: "Payment Type", key: "pay_type" },
  { label: "Shipping Type", key: "shipping_type" },
  { label: "Order Price", key: "price" },
  { label: "Margin", key: "partner_margin" },
];

const loadData = (item) => {
  return (
    {
      order_id: item.order_id,
      order_at: item.order_at,
      delivery_date: item.delivery_date,
      order_type: item.order_type,
      pay_type: item.pay_type,
      shipping_type: item.shipping_type,
      price: item.price,
      partner_margin: item.partner_margin,
    }
  )
}

const  List  = ({partnerId, date}) => {
    const [orderList, setOrderList] = useState([])
	const [activePage, setActivePage] = useState(1)
	const [perPage, setPerPage] = useState(15)
	const [totalData, setTotalData] = useState(0)
	const [page, setPage] = useState(1)
    const [refresh, setRefresh] = useState(false)

	const getQueryParams = () => {
		let params = Object.assign({per_page: perPage, page:page});
		return params;
	}

	const getOrderList = (queryParams) =>{
		const params = {
			month : date.getMonth() + 1,
			year: date.getFullYear(),
			...queryParams
		}
		getPaginatedList(`partners/${partnerId}/completed_orders`, params)
			.then(res =>{
				setOrderList(res?.data?.data)
				setPerPage(res.headers['x-per-page'])
				setTotalData( res.headers['x-total'])
			})
			.catch(err =>{
				toast.error(err?.message)
			})
	}

    useEffect(()=>{
        getOrderList(getQueryParams())
    }, [refresh])

    return (
        <div className="main-content">
                <div className="card-block">
                    <div className="block-body">
                      <div className="page-header">
                        <h2 className="page-title" style={{fontWeight:'bold'}}>Order List</h2>
                        <div div className="ml-auto" style={{display: "flex"}}>
                          <ExportCSV
                          title = "Partner Commissions"
                          data={orderList}
                          headers={headers} />`
                        </div>
                      </div>
                        <table className="order-table table table-striped">
                        <thead>
                        <tr>
                            <th style={{width: '20px'}} className='text-center'>id</th>
                            <th className='text-center'>Order Date</th>
                            <th className='text-center'>Delivery Date</th>
                            <th className='text-center'>Order Type</th>
                            <th className='text-center'>Payment Type</th>
                            <th className='text-center'>Price</th>
                            <th className='text-center'>Partner Margin</th>
                            <th className='text-center'>shipping type</th>
                        </tr>
                        </thead>
                        <tbody>
                        {orderList?.length > 0 ? orderList?.map((item, index) => {
                            return (
                                <tr key={index}>
                                <td className='text-center'>{item.order_id}</td>
                                <td className='text-center'>{moment(item.order_at).format('DD/MM/YY') }</td>
                                <td className='text-center'>{moment(item.delivery_date).format('DD/MM/YY')}</td>
                                <td className='text-center'>{item.order_type}</td>
                                <td className='text-center'>{humanize(item.pay_type)}</td>
                                <td className='text-center'>{item.price}</td>
                                <td className='text-center'>{item.partner_margin}</td>
                                <td className='nowrap text-center'>{humanize(item.shipping_type)}</td>
                                </tr>
                            );
                        }) : <tr><td colSpan={7}>No partners found</td></tr>}
                        </tbody>
                        </table>
                    </div>
                    {/* <div className="mt-3">
                        <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={1}
                        itemsCountPerPage={parseInt(perPage)}
                        totalItemsCount={parseInt(totalData)}
                        pageRangeDisplayed={10}
                        onChange={(pageNumber)=> {
                            setPage(pageNumber)
                            setRefresh(!refresh)
                        }}
                        />
                    </div> */}
                </div>
            </div>
    )
}

export default withRouter(List);
